import React from 'react';
import styled from 'styled-components';

const Container  = styled.div`
    padding: 5rem;
`;

const Product = props => {

  return (
    <Container>
      <h3>Product channel</h3>
    </Container>
  );
};

Product.propTypes = {};

export default Product;
